var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4958 11.6272L14.5593 15.6907L15.6907 14.5594L11.6271 10.4958C12.4874 9.3935 13 8.00661 13 6.5C13 2.91015 10.0898 3.13835e-07 6.5 0C2.91015 6.3984e-07 -6.3984e-07 2.91015 0 6.5C-3.13835e-07 10.0899 2.91015 13 6.5 13C8.0066 13 9.39347 12.4874 10.4958 11.6272ZM11.4 6.5C11.4 9.2062 9.20619 11.4 6.5 11.4C3.7938 11.4 1.6 9.2062 1.6 6.5C1.6 3.7938 3.7938 1.6 6.5 1.6C9.20619 1.6 11.4 3.7938 11.4 6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.d2d64b1fee6dd92f0e7994f3ad3478af.svg";
export { ForwardRef as ReactComponent };